module.exports = __webpack_public_path__ + "img/logo-text-black.8beae5a8.png";